import { useState, type FormEvent } from 'react';
import { discussions } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const sideTopics = [
  { name: '# 你心中最好的校园片结局', posts: '3,241', hot: true },
  { name: '# 初恋电影里最心动的一句台词', posts: '2,870', hot: true },
  { name: '# 求推荐一部能哭出来的小清新', posts: '1,905', hot: false },
  { name: '# 天台上的三万次日落 细节分析', posts: '1,433', hot: false },
];

export default function TalkSection() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState('');
  const [posted, setPosted] = useState(false);

  const toggleLike = (id: string) => setLiked((prev) => ({ ...prev, [id]: !prev[id] }));

  const handlePost = (e: FormEvent) => {
    e.preventDefault();
    if (!draft.trim()) return;
    setPosted(true);
    setDraft('');
  };

  return (
    <section id="talk" className="scroll-mt-24 bg-background-100 py-10 md:py-14 border-y border-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="FAN TALK"
          title="影迷话题 · 一起聊两句"
          desc="这里没有剧透预警，只有同好。你的一句短评，可能就是别人今晚的观影理由。"
          actionLabel="进入话题广场"
          actionHref="#talk"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <div className="lg:col-span-8 flex flex-col gap-4">
            <form
              onSubmit={handlePost}
              className="bg-background-50 border border-background-200 rounded-lg p-4"
            >
              <div className="flex items-start gap-3">
                <span className="shrink-0 w-10 h-10 rounded-full bg-primary-100 text-primary-700 font-bold flex items-center justify-center">
                  我
                </span>
                <textarea
                  value={draft}
                  onChange={(e) => setDraft(e.target.value.slice(0, 200))}
                  placeholder="说点什么吧，比如你最近重看的一部青春片…"
                  maxLength={200}
                  rows={2}
                  className="flex-1 resize-none bg-background-100 border border-background-200 rounded-md px-3 py-2 text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400"
                />
              </div>
              <div className="mt-3 flex items-center justify-between">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-emotion-line" />
                    表情
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-movie-line" />
                    关联影片
                  </span>
                  <span>{draft.length}/200</span>
                </div>
                <button
                  type="submit"
                  className="h-9 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  发布短评
                </button>
              </div>
              {posted && (
                <div className="mt-3 text-xs text-primary-700 bg-primary-50 border border-primary-200 rounded-md px-3 py-2">
                  <i className="ri-checkbox-circle-line mr-1" />
                  已收到你的短评（演示环境，不会真正发布）
                </div>
              )}
            </form>

            {discussions.map((d) => (
              <article
                key={d.id}
                className="bg-background-50 border border-background-200 rounded-lg p-4 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-secondary-200 text-secondary-900 font-bold flex items-center justify-center text-sm">
                    {d.initial}
                  </span>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-foreground-900">{d.user}</div>
                    <div className="text-xs text-foreground-500">{d.time}</div>
                  </div>
                  <span className="ml-auto hidden sm:inline-flex items-center gap-1 text-xs text-foreground-600 bg-background-100 border border-background-200 px-2.5 py-1 rounded-full whitespace-nowrap">
                    <i className="ri-film-line" />
                    {d.film}
                  </span>
                </div>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{d.content}</p>
                <div className="mt-3 flex items-center gap-5 text-xs text-foreground-500">
                  <button
                    type="button"
                    onClick={() => toggleLike(d.id)}
                    className={`inline-flex items-center gap-1 transition-colors ${
                      liked[d.id] ? 'text-accent-600' : 'hover:text-accent-600'
                    }`}
                  >
                    <i className={liked[d.id] ? 'ri-heart-fill' : 'ri-heart-line'} />
                    {d.likes}
                  </button>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line" />
                    {d.replies} 条回复
                  </span>
                  <span className="inline-flex items-center gap-1 hover:text-primary-700">
                    <i className="ri-share-forward-line" />
                    分享
                  </span>
                </div>
              </article>
            ))}
          </div>

          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 bg-background-50 border border-background-200 rounded-lg p-5">
              <h3 className="text-base font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-fire-line text-accent-500" />
                热门话题
              </h3>
              <ul className="mt-4 flex flex-col gap-1">
                {sideTopics.map((t, idx) => (
                  <li key={t.name}>
                    <a
                      href="#talk"
                      className="flex items-center gap-3 py-2.5 px-2 -mx-2 rounded-md hover:bg-primary-50 transition-colors"
                    >
                      <span
                        className={`shrink-0 w-6 h-6 rounded-md text-xs font-bold flex items-center justify-center ${
                          idx < 2 ? 'bg-accent-500 text-background-50' : 'bg-background-100 text-foreground-500'
                        }`}
                      >
                        {idx + 1}
                      </span>
                      <span className="flex-1 text-sm text-foreground-800 line-clamp-1">{t.name}</span>
                      <span className="text-xs text-foreground-500 whitespace-nowrap">{t.posts}</span>
                    </a>
                  </li>
                ))}
              </ul>

              <div className="mt-4 pt-4 border-t border-background-200">
                <h3 className="text-base font-bold text-foreground-950 flex items-center gap-2">
                  <i className="ri-user-heart-line text-primary-600" />
                  活跃影迷
                </h3>
                <div className="mt-3 flex flex-wrap gap-2">
                  {['柚子同学', '晚风十三班', '栗子不加糖', '胶片小卖部', '橘子汽水加冰', '林间追光'].map(
                    (u) => (
                      <span
                        key={u}
                        className="text-xs text-foreground-700 bg-background-100 border border-background-200 px-2.5 py-1 rounded-full"
                      >
                        {u}
                      </span>
                    ),
                  )}
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}